import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import SecretariaService from '../../../../../services/secretaria-auth';
import Secretaria from './secretaria';


const ListarSecretarias = () => {

    const [secretarias, setSecs] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [secretaria, setSec] = useState("");


    async function fetchSecretarias() {
        const response = await SecretariaService.listar();
        if (response.data.length >= 1) {
            setSecs(response.data)
            setVazio(false)
        } else {
            setSecs([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setSec(id);
        setEditar(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a Secretaria?')) {
            await SecretariaService.deletar(id)
            alert("Secretaria deletada com sucesso!")
            fetchSecretarias();
        }
    }

    useEffect(() => {
        fetchSecretarias();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/institucional/secretaria/editar/${secretaria}`} />
        )
    } else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setSecs={setSecs}
                        setVazio={setVazio}
                        fetchSecretarias={fetchSecretarias}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={2}>
                            {secretarias.map((secretaria, index) =>
                                <Secretaria
                                    fetchSecretarias={fetchSecretarias}
                                    secretaria={secretaria}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarSecretarias;